// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "main.module." + {"174":"c9978fff276b37fec0c0","941":"48314f17beb186b28b1e"}[chunkId] + ".js";
};